import React, { useState } from "react";
import "./SideNavigationFree1.scss";

interface FlowItem {
  id: number | string;
  name: string;
  url?: string;
  childs?: FlowItem[];
}

interface Props {
  tree: FlowItem[];
  onItemClick?: (item: FlowItem) => void;
}

const SideNavigationFree1: React.FC<Props> = ({
  tree,
  onItemClick,
}) => {
  const [activeMain, setActiveMain] = useState<number | string | null>(
    tree[0]?.id ?? null
  );
  const [activeChild, setActiveChild] = useState<number | string | null>(null);
  const [activeGrand, setActiveGrand] = useState<number | string | null>(null);
  const [hasInteracted, setHasInteracted] = useState<boolean>(false);

  const handleMainClick = (item: FlowItem) => {
    setActiveMain(item.id);
    setActiveChild(null);
    setActiveGrand(null);
    onItemClick?.(item);
    setHasInteracted(true);
  };

  const handleChildClick = (main: FlowItem, child: FlowItem) => {
    setActiveMain(main.id);
    setActiveChild(child.id);
    setActiveGrand(null);
    onItemClick?.(child);
    setHasInteracted(true);
  };

  const handleGrandClick = (
    main: FlowItem,
    child: FlowItem,
    grand: FlowItem
  ) => {
    setActiveMain(main.id);
    setActiveChild(child.id);
    setActiveGrand(grand.id);
    onItemClick?.(grand);
    setHasInteracted(true);
  };

  return (
    <div className="sdf1-flow-wrapper">
      <div className="sdf1-flow-nav">
        {tree.map((item) => {
          const hasDropdown = item.childs && item.childs.length > 0;
          const isActiveMain = activeMain === item.id;

          return (
            <div
              key={item.id}
              className={`sdf1-step ${isActiveMain ? "sdf1-active" : ""}`}
            >
              <div
                className={`sdf1-step-main ${isActiveMain ? "sdf1-active" : ""}`}
                onClick={() => handleMainClick(item)}
              >
                <span className="sdf1-step-label">
                  {item.name}
                  {isActiveMain && (
                    <span className="sdf1-you-are-here">
                      {hasInteracted ? "You are here" : "Start here"}
                    </span>
                  )}
                </span>

                {hasDropdown && <span className="sdf1-arrow">▾</span>}
              </div>

              {hasDropdown && (
                <div className="sdf1-dropdown">
                  {item.childs!.map((child) => {
                    const hasGrand = child.childs && child.childs.length > 0;
                    const isActiveChild =
                      isActiveMain && activeChild === child.id;

                    return (
                      <div
                        key={child.id}
                        className={`sdf1-dropdown-item ${
                          isActiveChild ? "sdf1-active" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChildClick(item, child);
                        }}
                      >
                        <div className="sdf1-for-third-background">
                          {child.name}
                          {hasGrand && (
                            <span className="sdf1-arrow-third">▾</span>
                          )}
                        </div>

                        {hasGrand && (
                          <div className="sdf1-dropdown-nested">
                            {child.childs!.map((grand) => {
                              const isActiveGrand =
                                isActiveChild && activeGrand === grand.id;

                              return (
                                <div
                                  key={grand.id}
                                  className={`sdf1-dropdown-item ${
                                    isActiveGrand ? "sdf1-active" : ""
                                  }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleGrandClick(item, child, grand);
                                  }}
                                >
                                  {grand.name}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideNavigationFree1;